export default {
    text: 'active.vs.passive.netChange',
    style: {
        fontWeight: 'normal'
    }
};
